module.exports = __webpack_public_path__ + "static/AWS-Iphone-fcc133586e894b655b173b1877bc4e92.mp4";